<app-table [columns]="columns" [loading]="loading" [value]="kataloge" filename="CHOP_KATALOGE.TITLE" sortField="jahr">
  <ng-template
    (onClick)="openDetail($event.row)"
    appActionButton
    icon="fal fa-search"
    labelKey="GLOBAL.DETAILS"></ng-template>
</app-table>
